import Vue from 'vue';
import addressupdateVueModelSchema from './addressupdate.vue.model.schema';
import AutomationReactivationVM from './reactivation.vue.model';

export default class AutomationAdressupdateVM extends AutomationReactivationVM {
  override async initialize(): Promise<void> {
    await super.initialize();
    this.formModel.schema = addressupdateVueModelSchema({
      validateFirstname: this.showFirstName,
      validateLastName: this.showLastName,
    });
  }

  override async submitForm() {
    this.isSubmitting = true;
    try {
      if (!this.formModel.validate()) {
        this.isSubmitting = false;
        return;
      }
      this.formModel.languageIso2 = Vue.$translation.get() ?? Vue.$config.values['language-default'];
      this.formModel.contactId = this.contactId;
      this.formModel.tenantKey = this.tenantKey;
      const req = this.formModel;
      await Vue.$service.v2.api.addressUpdate.postAddressUpdateFormPayload(req);
      this.isSubmitted = true;
    } catch (error: any) {
      this.error = error;
    }
    this.isSubmitting = false;
  }
}
